export default __webpack_public_path__ + "static/dan@2x-e64446eb12dc29e2327829a8e5a93d45.jpg";